import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreTenantRoleList',
  props: {
    roles: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    userId: {
      type: String,
      required: false,
      default: null
    },
    scopeId: {
      type: Number,
      required: true
    },
    tenantId: {
      type: Number,
      required: false,
      default: 0
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    loadRolesInternally: {
      type: Boolean,
      required: false,
      default: true
    },
    availableRoles: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      loadedRoles: [],
      selectedRoles: [],
      search: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    comboRoles: function comboRoles() {
      return (this.loadRolesInternally === true ? this.loadedRoles : this.availableRoles).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    }
  }),
  watch: {
    scopeId: function scopeId() {
      if (this.loadRolesInternally === true) {
        this.fetchRoles();
      }
    },
    roles: function roles(val) {
      this.selectedRoles = val;
    }
  },
  mounted: function mounted() {
    if (this.loadRolesInternally === true) {
      this.fetchRoles();
    }

    this.selectedRoles = this.roles;
  },
  methods: {
    process: function process(a) {
      var roles = cloneDeep(a);
      this.search = '';
      this.$emit('rolesChosen', roles.map(function (role) {
        return {
          id: role.id,
          name: role.name
        };
      }), this.scopeId, this.tenantId);
    },
    fetchRoles: function fetchRoles() {
      var _this = this;

      ApiService.fetchRoles(this.scopeId, this.userId).then(function (res) {
        _this.loadedRoles = res;
      }).catch(function (error) {
        console.error(error);
      });
    },
    remove: function remove(item) {
      this.selectedRoles = this.selectedRoles.filter(function (role) {
        return item.id !== role.id;
      });
      this.process(this.selectedRoles);
    }
  }
};